export default {
  1: "p/m",
  3: "p/3m",
  6: "p/6m",
  12: "p/j",
};
